import ssrGlobal from '@/util/ssr-global';

type INamespace = {
    _silenced: boolean;
    constructors?: any[],
    instances?: any[],
    silence?: (state: boolean) => void;
};

let WeblogNamespace: INamespace;
const WEBLOGGER_SILENCE_KEY = 'WEBLOGGER_SILENCED';
// 在浏览器环境下统一一个命名空间，用来统计
if (typeof ssrGlobal !== 'undefined') {
    if (typeof ssrGlobal._WEBLOGGER !== 'object') {
        ssrGlobal._WEBLOGGER = {
            _silenced: false,
            constructors: [],
            instances: [],
            // 全局静默
            silence(state: boolean) {
                try {
                    if (state) {
                        sessionStorage.setItem(WEBLOGGER_SILENCE_KEY, '1');
                    } else {
                        sessionStorage.removeItem(WEBLOGGER_SILENCE_KEY);
                    }
                    ssrGlobal._WEBLOGGER.instances.forEach((i: any) => {
                        i?.silence(state);
                    });
                } catch (err) {}
            }
        };
    }
    WeblogNamespace = ssrGlobal._WEBLOGGER;
}
export const initSilence = () => {
    if (WeblogNamespace?.silence) {
        try {
            WeblogNamespace._silenced = !!sessionStorage.getItem(WEBLOGGER_SILENCE_KEY);
        } catch (err) {}
    }
};
/**
 * 记录一个 Weblog 类
 */
export const addClass = (C: any) => {
    // bootstrap 分级加载命名空间，后续废弃
    if (typeof ssrGlobal._GLOBAL_KS_WEBLOGGER_ !== 'undefined') {
        ssrGlobal._GLOBAL_KS_WEBLOGGER_.Factory = C;
    } else {
        ssrGlobal.Weblog = C;
    }
    if (WeblogNamespace?.constructors && C && WeblogNamespace.constructors.indexOf(C) === -1) {
        // 加个 id 区分
        C._classId = WeblogNamespace.constructors.length;
        WeblogNamespace.constructors.push(C);
    }
};
/**
 * 记录一个 Weblog 实例
 */
export const addInstance = (i: any) => {
    if (WeblogNamespace?.instances && i && WeblogNamespace.instances.indexOf(i) === -1) {
        WeblogNamespace.instances.push(i);
        if (WeblogNamespace._silenced) {
            i?.silence(true);
        }
    }
};
/**
 * 移除一个 Weblog 实例
 */
export const removeInstance = (i: any) => {
    if (WeblogNamespace?.instances) {
        const index = WeblogNamespace.instances.indexOf(i);
        if (index !== -1) {
            WeblogNamespace.instances.splice(index, 1);
        }
    }
};
